import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/elder-care/index";

export const Route = createFileRoute("/admin/_modules/_elder-care/elder-care")({
  component: Page,
});
